import React from "react";
import { Row, Col, Dropdown } from "react-bootstrap";
import { Rider } from "../../../../types/model";

type PickAndRankChoiceRidersProps = {
	allRiders: Rider[];
	selectedBestTrickRider?: string;
	setSelectedBestTrickRider: (id?: string) => void;
	selectedPeoplesChoiceRider?: string;
	setSelectedPeoplesChoiceRider: (id?: string) => void;
	labelSuffix: string; // e.g., "Men" or "Women"
};

const PickAndRankChoiceRiders: React.FC<PickAndRankChoiceRidersProps> = ({
	allRiders,
	selectedBestTrickRider,
	setSelectedBestTrickRider,
	selectedPeoplesChoiceRider,
	setSelectedPeoplesChoiceRider,
	labelSuffix,
}) => (
	<Row className="ms-4 mt-3 mb-2 fw-bold">
		<Col
			xs={12}
			md={6}
			className="mb-3 mb-md-0 justify-content-center d-flex flex-column align-items-center"
		>
			<div className="me-2 mb-2">{`Best Trick Rider (${labelSuffix}):`}</div>
			<Dropdown
				onSelect={(eventKey) => setSelectedBestTrickRider(eventKey ?? undefined)}
			>
				<Dropdown.Toggle
					variant="outline-light"
					id={`dropdown-best-trick-${labelSuffix.toLowerCase()}`}
					disabled={allRiders.length === 0}
					className="ms-2"
					size="lg"
				>
					{selectedBestTrickRider
						? (() => {
								const rider = allRiders.find((r) => r._id === selectedBestTrickRider);
								return rider ? `${rider.first_name} ${rider.last_name}` : "Select Rider";
							})()
						: "Select Rider"}
				</Dropdown.Toggle>
				<Dropdown.Menu>
					{allRiders.map((teamRider) => (
						<Dropdown.Item
							key={teamRider._id}
							eventKey={teamRider._id}
							active={selectedBestTrickRider === teamRider._id}
						>
							{teamRider.first_name} {teamRider.last_name}
						</Dropdown.Item>
					))}
				</Dropdown.Menu>
			</Dropdown>
		</Col>
		<Col
			xs={12}
			md={6}
			className="justify-content-center d-flex flex-column align-items-md-start align-items-center"
		>
			<div className="me-2 mb-2">{`People's Choice Rider (${labelSuffix}):`}</div>
			<Dropdown
				onSelect={(eventKey) => setSelectedPeoplesChoiceRider(eventKey ?? undefined)}
			>
				<Dropdown.Toggle
					variant="outline-light"
					id={`dropdown-peoples-choice-${labelSuffix.toLowerCase()}`}
					disabled={allRiders.length === 0}
					className="ms-2"
					size="lg"
				>
					{selectedPeoplesChoiceRider
						? (() => {
								const rider = allRiders.find((r) => r._id === selectedPeoplesChoiceRider);
								return rider ? `${rider.first_name} ${rider.last_name}` : "Select Rider";
							})()
						: "Select Rider"}
				</Dropdown.Toggle>
				<Dropdown.Menu>
					{allRiders.map((teamRider) => (
						<Dropdown.Item
							key={teamRider._id}
							eventKey={teamRider._id}
							active={selectedPeoplesChoiceRider === teamRider._id}
						>
							{teamRider.first_name} {teamRider.last_name}
						</Dropdown.Item>
					))}
				</Dropdown.Menu>
			</Dropdown>
		</Col>
	</Row>
);

export default PickAndRankChoiceRiders;